export const Application = {
    TOKEN: "TOKEN",
    USER: "USER-COOKIE",
    APP_NAME: "Admin Panel",
    APP_KEY: "2J5A1-Y1L1E-9R9S4-2I5N1-F1I2N-5I3T7E",
};

const App_PATH = "/v1/line-connect"

export const Path = {
    index:      App_PATH + "/",
    landing:    App_PATH + "/onboarding/login_landing/:lineId",
    login:      App_PATH + "/onboarding/login/:lineId",
    nationalId: App_PATH + "/onboarding/connect-with-id",
    consent:    App_PATH + "/onboarding/T&C",
    tNc_view:   App_PATH + "/onboarding/review/T&C",
    mobile:     App_PATH + "/onboarding/mobileNumber",
    otp:        App_PATH + "/onboarding/otp",
    decision:   App_PATH + "/onboarding/decision",
    account:    App_PATH + "/onboarding/account",
    success:    App_PATH + "/onboarding/success",

    mng_acc:     App_PATH + "/account/manage/mobile/:token",
    mng_vrf:     App_PATH + "/account/manage/verify/otp",
    mng_chg:     App_PATH + "/account/manage/change/:token",

    pay_channel:App_PATH + "/payment/channel",
    pay_amount: App_PATH + "/payment/amount",
    qrcode:     App_PATH + "/payment/qrcode",
    other_bank: App_PATH + "/payment/other-bank",

    expired:    App_PATH + "/content-expired/:msg",
};

export const Topic = {
    ANNOUNCE: "announcement",
    INFO: "information",
}

export const DeviceScreen = {
    MOBILE: "MOBILE",
    TABLET: "TABLET",
    DESKTOP: "DESKTOP"
}


export const ComponentDetail = {
    PRODUCT_ABOUT: "body.product-about",
    TABLE_IMAGE: "body.table-image",
    HOW_TO_REGISTER: "body.how-to-register",
    HOW_TO_APPLY: "body.how-to-apply",
    FAQ: "body.question-section",
    TERM_CONDITION: "body.term-and-con-section"
}

export const nationalIdMask = [/\d/, '-', /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, '-', /\d/];
export const mobileNumberMask = [/\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/]